export const STATUS_ACTIVE = 1;
export const STATUS_IN_TREATMENT = 2;
export const STATUS_COMPLETED = 3;
export const STATUS_PENDING = 4;
export const HELD_BY_GROUPS = {
  ORTHOSELECT: 1,
  DOCTORS: 2
};
